import { VARIABLE_TYPE } from './constants/content'

/**
 * @param {object} object
 * @param {string} path
 * @param {Array, object} path
 * @returns {function(): void}
 */
export const setValue = (object, path, value) => path.split('.')
  .reduce((obj, part, i) => {
    const [indexedProp, prop, index] = part.match(/(\w+)\[(\w+)\]$/) || []
    if (indexedProp) {
      obj[prop] = (typeof obj[prop] === 'object' && obj[prop] !== null) ? obj[prop] : []
      obj[prop][index] = path.split('.').length === ++i ? value : obj[prop][index] || {}
      return obj[prop][index]
    }

    obj[part] = path.split('.').length === ++i ? value : obj[part] || {}
    return obj[part]
  }, object)

export const getType = (entry) => {
  if (typeof entry === 'string') return VARIABLE_TYPE.STRING
  if (typeof entry === 'number') return VARIABLE_TYPE.NUMBER

  if (!entry) return

  if (entry instanceof Array) return VARIABLE_TYPE.ARRAY
  if (entry instanceof Object) return VARIABLE_TYPE.OBJECT
}

export function getUrlSearchParams () {
  if (typeof window === 'undefined') return {}
  if (!window.location.search) return {}

  const params = window.location.search.substring(1).split('&')
  const query = {}

  params && params
    .forEach(item => {
      const [key, value] = item.split('=')
      query[key] = value
    })

  return query
}

export const isProduction = process.env.NODE_ENV === 'production'
